import { constants } from "../../misc/constants";
import Scenario2 from "./Scenario2";
import { SbarUIConfig } from "../../components/ui/SbarUI";
import { TransformUIConfig } from "../../components/ui/TransformUI";
import MedsurgBaseScenarioPart from "../MedsurgBaseScenarioPart";
import { Window508Type } from "../MedsurgBaseScenario";

export default class Scenario2Part7 extends MedsurgBaseScenarioPart {

	chapterIds = {
		chapterCinematic1: 'medsurg-cinematic-2-1',
        chapterCinematic35: 'medsurg-cinematic-2-35',
        chapterCinematic36: 'medsurg-cinematic-2-36',
        chapterCinematic37: 'medsurg-cinematic-2-37',
        chapterCinematic38: 'medsurg-cinematic-2-38',
        chapterCinematic39: 'medsurg-cinematic-2-39',
        chapterCinematic40: 'medsurg-cinematic-2-40',
		chapterCinematic41: 'medsurg-cinematic-2-41',
        chapterCinematic42: 'medsurg-cinematic-2-42',
        chapterCinematic43: 'medsurg-cinematic-2-43',
        chapterCinematic44: 'medsurg-cinematic-2-44',
        chapterCinematic45: 'medsurg-cinematic-2-45',
        chapterCinematic46: 'medsurg-cinematic-2-46',
        chapterCinematic47: 'medsurg-cinematic-2-47', // rrt mask
        chapterCinematic26: 'medsurg-cinematic-2-26', // rrt o2
		//NEED O2 ANIM
		//NEED REBREATHER ANIM
		chapterCinematic78: 'medsurg-cinematic-2-78', // mask loop
        chapterCinematic34: 'medsurg-cinematic-2-34', // o2 loop
	}

	constructor(scenario: Scenario2, private onDone: () => void){
		super(scenario);
	}

	private PrInstanceID: string;
	private TalkInstanceID1: string;
	private ActionInstanceID1: string;
	private ActionInstanceID2: string;
	private ActionInstanceID3: string;
	private RememberDisplayed: boolean = false;
	private MoveInstanceID: string;

	private Talk1: boolean = false;
	private Talk2: boolean = false;
	private Talk3: boolean = false;
	private Talk4: boolean = false;
	private Action1: boolean = false;
	private Action2: boolean = false;
	private Action3: boolean = false;
	private Action4: boolean = false;
	private Action5: boolean = false;
	private Action6: boolean = false;
	private Action7: boolean = false;
	private Action8: boolean = false;
	private Action11: boolean = false;
	private Action12: boolean = false;
	private Action13: boolean = false;
	private Action14: boolean = false;
	private Action15: boolean = false;
	private Action31: boolean = false;
	private Action32: boolean = false;
	private Action33: boolean = false;

	private Talk01: boolean = false;
	private Talk02: boolean = false;
	private Talk03: boolean = false;
	private Talk04: boolean = false;
	private Talk05: boolean = false;
	private Action01: boolean = false;
	private Action02: boolean = false;
	private Action03: boolean = false;
	private Action04: boolean = false;
	private Action05: boolean = false;
	private Action06: boolean = false;
	private Action07: boolean = false;
	private Action08: boolean = false;
	private Action011: boolean = false;
	private Action012: boolean = false;
	private Action013: boolean = false;
	private Action014: boolean = false;
	private Action015: boolean = false;

	
	private Action001: boolean = false;
	private Action002: boolean = false;
	private Action003: boolean = false;
	private Action004: boolean = false;

	private TalkCount: number = 0;
	private OldTalkCount: number = 0;
	private ActionCount: number = 0;
	private OldActionCount: number = 0;
	private PAbool: boolean = false;
	private PObool: boolean = false;
	private CAbool: boolean = false;
	
	private PA2bool: boolean = false;
	private PO2bool: boolean = false;
	private CA2bool: boolean = false;
	private rebreatherChanged: boolean = false;
	private o2Changed: boolean = false;

	
	public get partId(): string {
		return constants.scenarios.scenario2.parts.level2Part7.id;
	}

	public get videoUrl(): string[] {
		//return ['./assets/videos/scenario2/video3' + this.scenario.avatarIndx + '.mp4'];
		return ['./assets/videos/scenario2/video30.mp4'];
	}

	public start() {
		const context = this;
		this.RememberDisplayed = false;
		context.segment1Step1IntroWalking();
	}

	private segment1Step1IntroWalking() {
		var context = this;
		this.scenario.destroyAllUIInstances();
		context.scenario.displayHeader();
		this.scenario.playAmbientLoop(this.scenario.audioHall);
		this.playVideoChapter(this.chapterIds.chapterCinematic1, () => {
			context.segment1Step2ContinueRoom1();
		});
    }

	private segment1Step4Remember() {
		var context = this;
		this.scenario.update508Window(Window508Type.Remember);
		this.scenario.displayRemember(() => {
			this.scenario.update508Window(Window508Type.Main);
			this.RememberDisplayed = true;
			context.scenario.destroyAllUIInstances();
			//context.skipPart();
		});
	}
	//use when skipping part for testing
	private skipPart() {
		var context = this;
        this.scenario.displayModalPop(
			null,
            'Skipping to part 8',
            () => {
                context.scenario.destroyAllUIInstances();
                    context.segment1StepFinal();
            }
        );
	}

    private segment1Step2ContinueRoom1() {
		this.scenario.destroyAllUIInstances();
        var context = this;
        context.scenario.gameManager.environment.blurFadeIn();
        this.scenario.displayModalPop(
			null,
            "Mrs. Phillips is due for her second rounds assessment.",
            () => {
				this.scenario.stopAmbientLoop();
				this.scenario.playAmbientLoop(this.scenario.audioRoom);
				context.scenario.destroyAllUIInstances();
				this.scenario.gameManager.environment.blurFadeOut();
				this.playVideoChapter(this.chapterIds.chapterCinematic35, () => {}, true);
				context.PreloadUis();
				if(this.RememberDisplayed === false) {
					context.segment1Step4Remember();
				}
				this.scenario.displayFooter(() => this.PrInstanceID, () => this.TalkInstanceID1, () => this.ActionInstanceID1, '4', '10', false, false);
				context.TalkCount = 4;
				context.ActionCount = 10;
				context.getFooterCounts();
            }
        );
    }

	private segment1Part5Debrief() {
		var context = this;
		context.scenario.gameManager.environment.blurFadeOut();
		context.scenario.displayDebrief(6500, () => { //9000??
			localStorage.setItem('ignoreResumePopup', 'true');
			window.location.reload();
		}, () => {
			context.segment1StepFinal();
		});
	}

	private segment1StepFinal() {
        var context = this;
        context.scenario.destroyAllUIInstances();
    	context.partEnd();
    }

	private partEnd() {
        var context = this;
		this.scenario.stopAmbientLoop();
		this.scenario.gameManager.customData.saveData.scenarios[context.scenario.currentLevel].lastPartId = this.partId;
		context.scenario.saveScore();
		context.onDone();
	}

    public PreloadUis(shouldHidePatientRecord?: boolean) {
        var context = this;
        this.PrInstanceID = (this.scenario as Scenario2).PrPhillipsID;
		context.scenario.gameManager.UiManager.updateUIInstance(this.PrInstanceID, {
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.Remember);
				}, 500);
				this.scenario.gameManager.UiManager.hideUiInstance(this.PrInstanceID);
				// if(this.RememberDisplayed === false) {
				// 	context.segment1Step4Remember();
				// }
			}
		})

		if(shouldHidePatientRecord) {
			this.scenario.gameManager.UiManager.hideUiInstance(this.PrInstanceID);
		} else {
			setTimeout(() => {
				context.scenario.update508Window(Window508Type.PatientRecord);
			}, 500);
		}

		(this.scenario as Scenario2).PrPhillipsID = this.PrInstanceID;

		context.TalkInstanceID1 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Talk',
			talks: [
				{
					toppx: '50px',
					titletext: 'How are you feeling?',
					onClicked: () => {
						this.segment1TalkFeeling();
					},
					disable: () => this.Talk1
				},
				{
					toppx: '150px',
					titletext: 'Can you describe your pain?',
					onClicked: () => {
						this.segment1TalkDescribe();
					},
					disable: () => this.Talk2
				},
				{
					toppx: '250px',
					titletext: 'On a scale of 0-10, can you rate your pain?',
					onClicked: () => {
						this.segment1TalkRate();
					},
					disable: () => this.Talk3
				},
				{
					toppx: '350px',
					titletext: 'Would you like something for the pain?',
					onClicked: () => {
						this.segment1TalkPills();
					},
					disable: () => this.Talk4
				}
			],
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				this.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
			}
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);

		this.ActionInstanceID1 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Action',
			talks: [
				{
					toppx: '50px',
					titletext: 'Take Vitals',
					onClicked: () => {
						this.segment1ActionVitals();
					},
					disable: () => this.Action1
				},
				{
					toppx: '150px',
					titletext: 'Administer Supplemental O2',
					onClicked: () => {
						this.segment1ActionO2();
					},
					disable: () => this.Action2
				},
				{
					toppx: '250px',
					titletext: 'Assess Patient',
					onClicked: () => {
						this.segment1ActionAssess();
					},
					disable: () => this.Action3
				},
				{
					toppx: '350px',
					titletext: 'Catheter: Check Patency',
					onClicked: () => {
						this.segment1ActionPatency();
					},
					disable: () => this.Action4
				},
				{
					toppx: '450px',
					titletext: 'Catheter: Check drainage color and characteristics',
					onClicked: () => {
						this.segment1ActionColor();
					},
					disable: () => this.Action5
				},
				{
					toppx: '550px',
					titletext: 'Catheter: Check Urine Output',
					onClicked: () => {
						this.segment1ActionUrine();
					},
					disable: () => this.Action6
				},
				{
					toppx: '650px',
					titletext: 'Call RRT',
					onClicked: () => {
						this.segment1ActionRRT();
					},
					disable: () => this.Action7
				},
				{
					toppx: '750px',
					titletext: 'Contact Provider',
					onClicked: () => {
						this.segment1ActionProvider();
					},
					disable: () => this.Action8
				}
			],
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
			}
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
	}

	private segment1ActionVitals() {
		var context = this;
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		this.ActionInstanceID2 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Take Vitals',
			talks: [
				{
					toppx: '50px',
					titletext: 'Temperature',
					onClicked: () => {
						context.segment1ActionTemperature();
					},
					disable: () => this.Action11
				},
				{
					toppx: '150px',
					titletext: 'Blood Pressure',
					onClicked: () => {
						context.segment1ActionBloodPressure();
					},
					disable: () => this.Action12
				},
				{
					toppx: '250px',
					titletext: 'Pulse',
					onClicked: () => {
						context.segment1ActionPulse();
					},
					disable: () => this.Action13
				},
				{
					toppx: '350px',
					titletext: 'Respirations',
					onClicked: () => {
						context.segment1ActionRespirations();
					},
					disable: () => this.Action14
				},
				{
					toppx: '450px',
					titletext: 'O2 Sat Level',
					onClicked: () => {
						context.segment1ActionSatLevel();
					},
					disable: () => this.Action15
				}
			],
			onClosed: () => {
				this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
				this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
			}
		});
	}

	private segment1ActionAssess() {
		var context = this;
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		this.ActionInstanceID3 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Assess Patient',
			talks: [
				{
					toppx: '50px',
					titletext: 'Check Peri Pad',
					onClicked: () => {
						context.segment1ActionPad();
					},
					disable: () => this.Action31
				},
				{
					toppx: '150px',
					titletext: 'Check Abdomen',
					onClicked: () => {
						context.segment1ActionAbdomen();
					},
					disable: () => this.Action32
				},
				{
					toppx: '250px',
					titletext: 'Check IV insertion site',
					onClicked: () => {
						context.segment1ActionIV();
					},
					disable: () => this.Action33
				}
			],
			onClosed: () => {
				this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID3);
				this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
			}
		});
	}

	private segment1TalkFeeling() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			scenario: this,
			toppx: '70px',
			titletext: 'How are you feeling?',
			isTalks: true,
			extBottom: true,
			extText: "I feel really weak and have the chills. I'm still lightheaded. I just feel terrible.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PObool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
						title: context.scenario.patientObservation,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2);
					this.PObool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2, context.scenario.patientObservation)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk1 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 8,
					quiztop: '5px',
					maxPoints: 250,
					talktext1: 'Patient Observation',
					talktext2: 'General',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'No active problems',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Lightheaded',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Weak',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Nausea',
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Trembling',
							onClicked: () => {
							},
						},
						{
							buttontop: '400px',
							buttontext: 'Sweating',
							onClicked: () => {
							},
						},
						{
							buttontop: '450px',
							buttontext: "Chills",
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '500px',
							buttontext: "Feels Terrible",
							isCorrect: true,
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic37, () => {
			if(this.o2Changed) {
				this.playVideoChapter(this.chapterIds.chapterCinematic35, () => {}, true); //NEED O2 ANIM, CHANGE CINEMATIC LEFT TO O2 LOOP - all 35s have been updated on video file.
			} else this.playVideoChapter(this.chapterIds.chapterCinematic35, () => {}, true);
		});
	}

	private segment1TalkDescribe() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			scenario: this,
			toppx: '170px',
			titletext: 'Can you describe your pain?',
			isTalks: true,
			extBottom: true,
			extText: "My joints are aching. I feel a sharp pain in my abdomen.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2);
					this.PAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2, context.scenario.patientAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk2 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 7,
					quiztop: '5px',
					maxPoints: 125,
					talktext1: 'Pain Assessment',
					talktext2: 'Pain Description',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Sore',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Stabbing',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Burning',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Aching',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Throbbing',
							onClicked: () => {
							},
						},
						{
							buttontop: '400px',
							buttontext: 'Sharp',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '450px',
							buttontext: 'Unable to describe',
							onClicked: () => {
							},
						}
					]
				},
				{
					quizheight: 7,
					prequizheight: 7,
					quiztop: '520px',
					maxPoints: 125,
					talktext1: 'Pain Assessment',
					talktext2: 'Pain Location',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Abdomen',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Head',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Back',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Chest',
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Joints',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '400px',
							buttontext: 'Shoulder',
							onClicked: () => {
							},
						},
						{
							buttontop: '450px',
							buttontext: 'Unable to describe',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic38, () => {
			if(this.o2Changed) {
				this.playVideoChapter(this.chapterIds.chapterCinematic35, () => {}, true); //NEED O2 ANIM, CHANGE CINEMATIC LEFT TO O2 LOOP - video updated same as below
			} else this.playVideoChapter(this.chapterIds.chapterCinematic35, () => {}, true);
		});
	}

	private segment1TalkRate() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			scenario: this,
			toppx: '270px',
			titletext: 'On a scale of 0-10, can you rate your pain?',
			isTalks: true,
			isPainScale: true,
			painScaleMaxPoints: 100,
			painScaleCorrect: 6,
			extBottom: true,
			extText: "About a six.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				this.scenario.evaluateScoreForPainScale(updatedConfig);
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2);
					this.PAbool = true;
				}
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
					header: 'Pain Scale',
					list: '<li>'+updatedConfig.painAssessment+'</li>',
				}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2, context.scenario.patientAssessment)
				this.Talk3 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic39, () => {
			if(this.o2Changed) {
				this.playVideoChapter(this.chapterIds.chapterCinematic35, () => {}, true); //NEED O2 ANIM, CHANGE CINEMATIC LEFT TO O2 LOOP - video file was updated, same as video files below
			} else this.playVideoChapter(this.chapterIds.chapterCinematic35, () => {}, true);
		});
	}

	private segment1TalkPills() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			scenario: this,
			toppx: '370px',
			titletext: 'Would you like something for the pain?',
			isTalks: true,
			extBottom: true,
			extText: "Yes, please.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
					title: context.scenario.medicineAdministered,
				}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2);
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2, context.scenario.medicineAdministered)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk4 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 2,
					quiztop: '5px',
					maxPoints: 100,
					binaryq: true,
					talktext1: 'Medication Administered',
					talktext2: ' ',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Yes',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'No',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -300px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic40, () => {
			if(this.o2Changed) {
				this.playVideoChapter(this.chapterIds.chapterCinematic35, () => {}, true); //NEED O2 ANIM, CHANGE CINEMATIC LEFT TO O2 LOOP - alan - video file was updated. same as 35 below.
			} else this.playVideoChapter(this.chapterIds.chapterCinematic35, () => {}, true);
		});
	}

	private segment1ActionTemperature() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			scenario: this,
			toppx: '70px',
			titletext: 'Temperature',
			vitaltext: '99.0',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_temp.png',
			onSubmit: () => {
				this.Action11 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsVitalsID, {
					list: '<li>Temperature : 99.0</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionBloodPressure() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			scenario: this,
			toppx: '170px',
			titletext: 'Blood Pressure',
			vitaltext: '108/64',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_bp.png',
			onSubmit: () => {
				this.Action12 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsVitalsID, {
					list: '<li>Blood Pressure : 108/64</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionPulse() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			scenario: this,
			toppx: '270px',
			titletext: 'Pulse',
			vitaltext: '110',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_pulse.png',
			onSubmit: () => {
				this.Action13 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsVitalsID, {
					list: '<li>Pulse : 110</li>',
				})
				context.scenario.updateScore(100);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionRespirations() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '370px',
			scenario: this,
			titletext: 'Respirations',
			vitaltext: '22',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_respiration.png',
			onSubmit: () => {
				this.Action14 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsVitalsID, {
					list: '<li>Respirations : 22</li>',
				})
				context.scenario.updateScore(100);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -300px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionSatLevel() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			scenario: this,
			toppx: '470px',
			titletext: 'O2 Sat Level',
			vitaltext: '92% room air',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_o2.png',
			onSubmit: () => {
				this.Action15 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsVitalsID, {
					list: '<li>02 Sat Level : 92% room air</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -400px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionO2() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			scenario: this,
			toppx: '470px',
			titletext: 'Administer Supplemental O2.',
			isTalks: true,
			onSubmit: () => {
				context.scenario.updateScore(100);
				this.Action2 = true;
				this.ActionCount = this.OldActionCount - 1;
				context.scenario.gameManager.environment.blurFadeIn();
				setTimeout(() => {
					this.o2Changed = true;
					this.playVideoChapter(this.chapterIds.chapterCinematic34, () => {}, true);
				}, 1000)
				setTimeout(() => {
					context.scenario.gameManager.environment.blurFadeOut();
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1500);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
				context.getFooterCounts();
			},
			quiz: [
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -400px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionPad() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID3);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Assess Patient',
			scenario: this,
			toppx: '70px',
			titletext: 'Check Peri Pad',
			isTalks: true,
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2);
					this.PAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2, context.scenario.patientAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action31 = true;
				this.ActionCount = this.OldActionCount - 1;
				context.scenario.destroyAllUIInstances();
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID3);
				context.checkIfSubMenu2();
			},
			quiz: [
				{
					quizheight: 4,
					quiztop: '5px',
					maxPoints: 500,
					talktext1: 'Patient Assessment',
					talktext2: 'Peri Pad',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'In place; light amount; light pink drainage',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'In place; moderate amount; dark red drainage',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'In place; heavy amount; dark red drainage',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'In place; no drainage',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);

		context.scenario.displayModalPop(
			null,
            'Peri pad is in place with moderate, dark red drainage.',
            () => {
				context.scenario.update508Window(Window508Type.TransformUI);
                context.scenario.endModalPop();
            }
        );
	}

	private segment1ActionAbdomen() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID3);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Assess Patient',
			scenario: this,
			toppx: '170px',
			titletext: 'Check Abdomen',
			isTalks: true,
			extTop: true,
			extImg: 'AssessingAbdominal',
			extText: 'Abdomen feels firm and has mild distention.',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2);
					this.PAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2, context.scenario.patientAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action32 = true;
				this.ActionCount = this.OldActionCount - 1;
				context.scenario.destroyAllUIInstances();
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID3);
				context.checkIfSubMenu2();
			},
			quiz: [
				{
					quizheight: 4,
					quiztop: '5px',
					maxPoints: 750,
					talktext1: 'Patient Assessment',
					talktext2: 'Abdomen',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Soft',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Firm',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Rigid',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Distention',
							isCorrect: true,
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionIV() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID3);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Assess Patient',
			scenario: this,
			toppx: '270px',
			titletext: 'Check IV insertion site',
			isTalks: true,
			extTop: true,
			extImg: 't21',
			extText: 'Intact, no redness, no leakage',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2);
					this.PAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2, context.scenario.patientAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action33 = true;
				this.ActionCount = this.OldActionCount - 1;
				context.scenario.destroyAllUIInstances();
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID3);
				context.checkIfSubMenu2();
			},
			quiz: [
				{
					quizheight: 7,
					quiztop: '5px',
					maxPoints: 1250,
					talktext1: 'Patient Assessment',
					talktext2: 'IV Insertion Site',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Intact',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'No redness',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'No leakage',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Redness',
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Leakage',
							onClicked: () => {
							},
						},
						{
							buttontop: '400px',
							buttontext: 'Infection',
							onClicked: () => {
							},
						},
						{
							buttontop: '450px',
							buttontext: 'Non-intact dressing',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionPatency() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Actions',
			scenario: this,
			toppx: '270px',
			titletext: 'Catheter: Check Patency',
			isTalks: true,
			extTop: true,
			extImg: 'PDEquipmentStepOne',
			extText: 'Patent',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.CAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
						title: context.scenario.catheter,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2);
					this.CAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2, context.scenario.catheter)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action4 = true;
				this.ActionCount = this.OldActionCount - 1;
				context.scenario.destroyAllUIInstances();
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
				context.getFooterCounts();
			},
			quiz: [
				{
					quizheight: 2,
					quiztop: '5px',
					maxPoints: 500,
					binaryq: true,
					talktext1: 'Catheter',
					talktext2: 'Patency',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Yes',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'No',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionColor() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Actions',
			scenario: this,
			toppx: '370px',
			titletext: 'Catheter: Check drainage color and characteristics',
			isTalks: true,
			extTop: true,
			extImg: 't22',
			extText: 'Drainage color: Amber',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.CAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
						title: context.scenario.catheter,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2);
					this.CAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2, context.scenario.catheter)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action5 = true;
				this.ActionCount = this.OldActionCount - 1;
				context.scenario.destroyAllUIInstances();
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
				context.getFooterCounts();
			},
			quiz: [
				{
					quizheight: 4,
					quiztop: '5px',
					maxPoints: 250,
					talktext1: 'Catheter',
					talktext2: 'Drainage color',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Clear',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Straw',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: "Amber",
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: "Dark Red",
							onClicked: () => {
							},
						}
					]
				},
				{
					quizheight: 2,
					prequizheight: 4,
					quiztop: '410px',
					maxPoints: 250,
					talktext1: 'Catheter',
					talktext2: 'Drainage characteristics',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Clear',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Cloudy',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -300px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionUrine() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Actions',
			scenario: this,
			toppx: '470px',
			titletext: 'Catheter: Check Urine Output',
			isTalks: true,
			extTop: true,
			extImg: 't15',
			extText: 'Output 400 ml',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.CAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
						title: context.scenario.catheter,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2);
					this.CAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2, context.scenario.catheter)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action6 = true;
				this.ActionCount = this.OldActionCount - 1;
				context.scenario.destroyAllUIInstances();
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
				context.getFooterCounts();
			},
			quiz: [
				{
					quizheight: 4,
					quiztop: '5px',
					maxPoints: 500,
					binaryq: true,
					talktext1: 'Catheter',
					talktext2: 'Urine Output',
					talks: [
						{
							buttontop: '150px',
							buttontext: '500 ml',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: '400 ml',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: '300 ml',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: '100 ml',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -400px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionRRT() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.destroyAllUIInstances();
		this.Action7 = true;
		context.getFooterCounts();
	}

	private segment1ActionProvider() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.destroyAllUIInstances();
		this.Action8 = true;
		context.getFooterCounts();
	}

	private getFooterCounts() {
		var context = this;
		this.OldTalkCount = this.TalkCount;
		this.OldActionCount = this.ActionCount;
		if(this.Action7 === true) {
			context.scenario.updateFooter('0', '0', true, true);
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			context.scenario.update508Window(Window508Type.Main);
			context.scenario.hideFooter();
			context.segment1PartEndingStartRRT();
		}
		else if(this.Action8 === true) {
			context.scenario.updateFooter('0', '0', true, true);
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			context.scenario.update508Window(Window508Type.Main);
			context.scenario.hideFooter();
			context.segment1PartEndingStartProvider();
		}
		else if(this.TalkCount === 0 && this.ActionCount !== 0) {
			context.scenario.updateFooter('0', this.ActionCount.toString(), true, false);
			context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
			context.scenario.update508Window(Window508Type.Main);
		}
		else {
			context.scenario.updateFooter(this.TalkCount.toString(), this.ActionCount.toString(), false, false)
		};
	}

	private checkIfSubMenu() {
		var context = this;
		if(this.Action11 === true && this.Action12 === true && this.Action13 === true && this.Action14 === true && this.Action15 === true) {
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);	
			this.Action1 = true;
			this.ActionCount = this.OldActionCount - 1;
		};
		context.getFooterCounts();
	}

	private checkIfSubMenu2() {
		var context = this;
		if(this.Action31 === true && this.Action32 === true && this.Action33 === true) {
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
			this.Action3 = true;
		};
		context.getFooterCounts();
	}

	private segment1PartEndingStartRRT() {
		var context = this;
		if(this.o2Changed) {
			this.playVideoChapter(this.chapterIds.chapterCinematic26, () => {
				context.scenario.gameManager.environment.blurFadeIn();
				context.scenario.showProvider(
					"Thanks, we'll take Mrs. Phillips to the OR. Great job!",
					() => {
						context.segment1showSbar();
					}
				);
			});
		} else {
			this.playVideoChapter(this.chapterIds.chapterCinematic36, () => {
				context.scenario.gameManager.environment.blurFadeIn();
				context.scenario.showProvider(
					"Thanks, we'll take Mrs. Phillips to the OR. Great job!",
					() => {
						context.segment1showSbar();
					}
				);
			});
		}
	}

	private segment1PartEndingStartProvider() {
		var context = this;
		context.scenario.gameManager.environment.blurFadeIn();
		context.scenario.showProvider(
			"Hi Nurse, what's the situation?",
			() => {
				context.segment1showSbar();
			},
			'frame_mentor'
		);
	}

	private segment1showSbar() {
		var context = this;
		context.scenario.update508Window(Window508Type.SbarUI)
		this.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.SbarUI, {
			s: {
				maxPoints: 250,
				options: [
					{
						text: 'Drop in patients vitals',
						isCorrect: true
					},
					{
						text: 'Increased bleeding found in peri-pad',
						isCorrect: true
					},
					{
						text: 'Patrient is weak and lightheaded',
						isCorrect: true
					},
					{
						text: 'Change in LOC',
						isCorrect: true
					},
					{
						text: 'Hypoglycemia',
						isCorrect: false
					}
				]
			},
			basic: this.scenario.getScenarioDataEntryItems((this.scenario as Scenario2).phillipsBasicID),
			nurses: this.scenario.getScenarioDataEntryItems((this.scenario as Scenario2).phillipsNursesID),
			r: {
				maxPoints: 200,
				options: [
					{
						text: 'Medication',
						isCorrect: false
					},
					{
						text: 'Stat Labs',
						isCorrect: true
					},
					{
						text: 'CT Scan',
						isCorrect: false
					},
					{
						text: 'Discharge',
						isCorrect: false
					}
				]
			},
			correctFeedback: 'Good job, you have correctly relayed critical information. Please review the SBAR and continue.',
			incorrectFeedback: 'You have incorrectly relayed critical information. Accurate patient information ensures patient safety and quality care provided by medical staff and Providers. Please continue to review the corrected SBAR.',
			onSubmitted: (result: SbarUIConfig) => {
				this.scenario.evaluateScoreForSbar(result);
			},
			onClose: (result: SbarUIConfig) => {
				context.scenario.destroyAllUIInstances();
				if(this.Action7 === true) {
					context.segment1Part5Debrief();
				}
				else if(this.Action8 === true) {
					context.scenario.showProvider(
						"Thanks for the update. I'll go ahead and order stat H&H labs for Mrs. Phillips and notify the OR. Continue assessing your patient. You'll be notified when the labs come in.",
						() => {
							context.segment1PartContinueProvider();
						},
						'frame_mentor'
					);
				}
			},
			onSetWindow: (window: Window508Type) => {
				context.scenario.update508Window(window);
			}
		});
	}

	private segment1PartContinueProvider() {
		var context = this;
		context.scenario.gameManager.environment.blurFadeOut();
		this.scenario.displayModalPop(
			null,
            'Lab results are available.',
            () => {
                context.scenario.destroyAllUIInstances();
                    context.segment2PreloadUis();
            }
        );
	}

	private segment2PreloadUis() {
        var context = this;

		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsVitalsID, {
			title: 'Vitals - 2:00',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
			visit: context.scenario.visit3,
			lineBreak: true,
		});
		context.scenario.gameManager.UiManager.updateUIInstance(this.TalkInstanceID1, {
			talks: [
				{
					toppx: '50px',
					titletext: 'How are you feeling?',
					onClicked: () => {
						this.segment2TalkFeeling();
					},
					disable: () => this.Talk01
				},
				{
					toppx: '150px',
					titletext: 'Can you describe your pain?',
					onClicked: () => {
						this.segment2TalkDescribe();
					},
					disable: () => this.Talk02
				},
				{
					toppx: '250px',
					titletext: 'On a scale of 0-10, can you rate your pain?',
					onClicked: () => {
						this.segment2TalkRate();
					},
					disable: () => this.Talk03
				},
				{
					toppx: '350px',
					titletext: 'Do you know what day it is?',
					onClicked: () => {
						this.segment2TalkDay();
					},
					disable: () => this.Talk04
				},
				{
					toppx: '450px',
					titletext: "Do you know why you're here today?",
					onClicked: () => {
						this.segment2TalkWhy();
					},
					disable: () => this.Talk05
				}
			]
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);

		context.scenario.gameManager.UiManager.updateUIInstance(this.ActionInstanceID1, {
			talks: [
				{
					toppx: '50px',
					titletext: 'Take Vitals',
					onClicked: () => {
						this.segment2ActionVitals();
					},
					disable: () => this.Action01
				},
				{
					toppx: '150px',
					titletext: 'Check Peri Pad',
					onClicked: () => {
						context.segment2ActionPad();
					},
					disable: () => this.Action02
				},
				{
					toppx: '250px',
					titletext: 'Check Abdomen',
					onClicked: () => {
						context.segment2ActionAbdomen();
					},
					disable: () => this.Action03
				},
				{
					toppx: '350px',
					titletext: 'Check IV insertion site',
					onClicked: () => {
						context.segment2ActionIV();
					},
					disable: () => this.Action04
				},
				{
					toppx: '450px',
					titletext: 'Catheter: Check Patency',
					onClicked: () => {
						this.segment2ActionPatency();
					},
					disable: () => this.Action05
				},
				{
					toppx: '550px',
					titletext: 'Catheter: Check drainage color and characteristics',
					onClicked: () => {
						this.segment2ActionColor();
					},
					disable: () => this.Action06
				},
				{
					toppx: '650px',
					titletext: 'Catheter: Check Urine Output',
					onClicked: () => {
						this.segment2ActionUrine();
					},
					disable: () => this.Action07
				},
				{
					toppx: '750px',
					titletext: 'Call RRT',
					onClicked: () => {
						this.segment2ActionRRT();
					},
					disable: () => this.Action08
				}
			]
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);

		context.ActionCount = 8;
		context.TalkCount = 5;
		context.getFooterCounts2();
	}

	private segment2ActionVitals() {
		var context = this;
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		this.ActionInstanceID2 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Take Vitals',
			talks: [
				{
					toppx: '50px',
					titletext: 'Temperature',
					onClicked: () => {
						context.segment2ActionTemperature();
					},
					disable: () => this.Action011
				},
				{
					toppx: '150px',
					titletext: 'Blood Pressure',
					onClicked: () => {
						context.segment2ActionBloodPressure();
					},
					disable: () => this.Action012
				},
				{
					toppx: '250px',
					titletext: 'Pulse',
					onClicked: () => {
						context.segment2ActionPulse();
					},
					disable: () => this.Action013
				},
				{
					toppx: '350px',
					titletext: 'Respirations',
					onClicked: () => {
						context.segment2ActionRespirations();
					},
					disable: () => this.Action014
				},
				{
					toppx: '450px',
					titletext: 'O2 Sat Level',
					onClicked: () => {
						context.segment2ActionSatLevel();
					},
					disable: () => this.Action015
				}
			],
			onClosed: () => {
				this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
				this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
			}
		});
	}

	private segment2TalkFeeling() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '70px',
			loadQuiz: true,
			scenario: this,
			titletext: 'How are you feeling?',
			isTalks: true,
			extBottom: true,
			extText: "I still really... feel terrible.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PO2bool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
						title: context.scenario.patientObservation,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit3);
					this.PO2bool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit3, context.scenario.patientObservation)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk01 = true;
				this.TalkCount = this.OldTalkCount - 1;
				context.scenario.destroyAllUIInstances();
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.scenario.gameManager.UiManager.showUiInstance(this.TalkInstanceID1);
				context.getFooterCounts2();
			},
			quiz: [
				{
					quizheight: 8,
					quiztop: '5px',
					maxPoints: 100,
					talktext1: 'Patient Observation',
					talktext2: 'General',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'No active problems',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Lightheaded',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Weak',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Nausea',
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Trembling',
							onClicked: () => {
							},
						},
						{
							buttontop: '400px',
							buttontext: 'Sweating',
							onClicked: () => {
							},
						},
						{
							buttontop: '450px',
							buttontext: "Chills",
							onClicked: () => {
							},
						},
						{
							buttontop: '500px',
							buttontext: "Feels Terrible",
							isCorrect: true,
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic42, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic34, () => {}, true);
		});
	}

	private segment2TalkDescribe() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '170px',
			loadQuiz: true,
			scenario: this,
			titletext: 'Can you describe your pain?',
			isTalks: true,
			extBottom: true,
			extText: "I don't know. I feel... funny. My stomach and shoulder hurts.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PA2bool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit3);
					this.PA2bool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit3, context.scenario.patientAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk02 = true;
				this.TalkCount = this.OldTalkCount - 1;
				context.scenario.destroyAllUIInstances();
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.scenario.gameManager.UiManager.showUiInstance(this.TalkInstanceID1);
				context.getFooterCounts2();
			},
			quiz: [
				{
					quizheight: 7,
					quiztop: '5px',
					maxPoints: 100,
					talktext1: 'Pain Assessment',
					talktext2: 'Pain Description',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Sore',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Stabbing',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Burning',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Aching',
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Throbbing',
							onClicked: () => {
							},
						},
						{
							buttontop: '400px',
							buttontext: 'Sharp',
							onClicked: () => {
							},
						},
						{
							buttontop: '450px',
							buttontext: 'Unable to describe',
							isCorrect: true,
							onClicked: () => {
							},
						}
					]
				},
				{
					quizheight: 7,
					prequizheight: 7,
					quiztop: '520px',
					maxPoints: 100,
					talktext1: 'Pain Assessment',
					talktext2: 'Pain Location',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Abdomen',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Head',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Back',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Chest',
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Joints',
							onClicked: () => {
							},
						},
						{
							buttontop: '400px',
							buttontext: 'Shoulder',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '450px',
							buttontext: 'Unable to describe',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic43, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic34, () => {}, true);
		});
	}

	private segment2TalkRate() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '270px',
			loadQuiz: true,
			scenario: this,
			titletext: 'On a scale of 0-10, can you rate your pain?',
			isTalks: true,
			isPainScale: true,
			painScaleMaxPoints: 100,
			painScaleCorrect: 7,
			extBottom: true,
			extText: "I think a seven.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				this.scenario.evaluateScoreForPainScale(updatedConfig);
				if(this.PA2bool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit3);
					this.PA2bool = true;
				}
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
					header: 'Pain Scale',
					list: '<li>'+updatedConfig.painAssessment+'</li>',
				}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit3, context.scenario.patientAssessment)
				this.Talk03 = true;
				this.TalkCount = this.OldTalkCount - 1;
				context.scenario.destroyAllUIInstances();
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.scenario.gameManager.UiManager.showUiInstance(this.TalkInstanceID1);
				context.getFooterCounts2();
			},
			quiz: [
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic44, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic34, () => {}, true);
		});
	}

	private segment2TalkDay() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '370px',
			loadQuiz: true,
			scenario: this,
			titletext: 'Do you know what day it is?',
			isTalks: true,
			extBottom: true,
			extText: "Today is Saturday.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PA2bool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit3);
					this.PA2bool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit3, context.scenario.patientAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk04 = true;
				this.TalkCount = this.OldTalkCount - 1;
				context.scenario.destroyAllUIInstances();
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.scenario.gameManager.UiManager.showUiInstance(this.TalkInstanceID1);
				context.getFooterCounts2();
			},
			quiz: [
				{
					quizheight: 5,
					quiztop: '5px',
					maxPoints: 200,
					talktext1: ' ',
					talktext2: 'Mental State',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Alert',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Oriented',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Confused',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Incoherent',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Nonresponse',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -300px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);

		context.scenario.displayModalPop(
			null,
            'Today is Tuesday.',
            () => {
				context.scenario.update508Window(Window508Type.TransformUI);
                context.scenario.endModalPop();
				this.playVideoChapter(this.chapterIds.chapterCinematic45, () => {
					this.playVideoChapter(this.chapterIds.chapterCinematic34, () => {}, true);
				});
            }
        );
	}

	private segment2TalkWhy() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '470px',
			loadQuiz: true,
			scenario: this,
			titletext: "Do you know why you're here today?",
			isTalks: true,
			extBottom: true,
			extText: "I... not... sure...",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PA2bool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit3);
					this.PA2bool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit3, context.scenario.patientAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk05 = true;
				this.TalkCount = this.OldTalkCount - 1;
				context.scenario.destroyAllUIInstances();
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.scenario.gameManager.UiManager.showUiInstance(this.TalkInstanceID1);
				context.getFooterCounts2();
			},
			quiz: [
				{
					quizheight: 5,
					quiztop: '5px',
					maxPoints: 200,
					talktext1: ' ',
					talktext2: 'Mental State',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Alert',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Oriented',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Confused',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Incoherent',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Nonresponsive',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -400px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic46, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic34, () => {}, true);
		});
	}

	private segment2ActionTemperature() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '70px',
			loadQuiz: true,
			scenario: this,
			titletext: 'Temperature',
			vitaltext: '97.8',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_temp.png',
			onSubmit: () => {
				this.Action011 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsVitalsID, {
					list: '<li>Temperature : 97.8</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu3();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment2ActionBloodPressure() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '170px',
			loadQuiz: true,
			scenario: this,
			titletext: 'Blood Pressure',
			vitaltext: '90/60',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_bp.png',
			onSubmit: () => {
				this.Action012 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsVitalsID, {
					list: '<li>Blood Pressure : 90/60</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu3();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment2ActionPulse() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			scenario: this,
			toppx: '270px',
			loadQuiz: true,
			titletext: 'Pulse',
			vitaltext: '128',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_pulse.png',
			onSubmit: () => {
				this.Action013 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsVitalsID, {
					list: '<li>Pulse : 128</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu3();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment2ActionRespirations() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '370px',
			loadQuiz: true,
			titletext: 'Respirations',
			vitaltext: '24',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_respiration.png',
			onSubmit: () => {
				this.Action014 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsVitalsID, {
					list: '<li>Respirations : 24</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu3();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -300px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment2ActionSatLevel() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '470px',
			loadQuiz: true,
			titletext: 'O2 Sat Level',
			vitaltext: '88% room air',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_o2.png',
			onSubmit: () => {
				this.Action015 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsVitalsID, {
					list: '<li>02 Sat Level : 88% room air</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu3();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -400px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment2ActionPad() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Assess Patient',
			toppx: '170px',
			loadQuiz: true,
			titletext: 'Check Peri Pad',
			isTalks: true,
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PA2bool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit3);
					this.PA2bool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit3, context.scenario.patientAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action02 = true;
				this.ActionCount = this.OldActionCount - 1;
				context.scenario.destroyAllUIInstances();
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
				context.getFooterCounts2();
			},
			quiz: [
				{
					quizheight: 4,
					quiztop: '5px',
					maxPoints: 300,
					talktext1: 'Patient Assessment',
					talktext2: 'Peri Pad',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'In place; light amount; light pink drainage',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'In place; moderate amount; dark red drainage',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'In place; heavy amount; dark red drainage',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'In place; no drainage',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);

		context.scenario.displayModalPop(
			null,
            'Peri pad is in place with heavy, dark red drainage.',
            () => {
				context.scenario.update508Window(Window508Type.TransformUI);
                context.scenario.endModalPop();
            }
        );
	}

	private segment2ActionAbdomen() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Assess Patient',
			toppx: '270px',
			loadQuiz: true,
			titletext: 'Check Abdomen',
			isTalks: true,
			extTop: true,
			extImg: 'AssessingAbdominal',
			extText: 'Abdomen feels rigid and has severe distention.',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PA2bool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit3);
					this.PA2bool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit3, context.scenario.patientAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action03 = true;
				this.ActionCount = this.OldActionCount - 1;
				context.scenario.destroyAllUIInstances();
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
				context.getFooterCounts2();
			},
			quiz: [
				{
					quizheight: 4,
					quiztop: '5px',
					maxPoints: 150,
					talktext1: 'Patient Assessment',
					talktext2: 'Abdomen',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Soft',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Firm',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Rigid',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Distention',
							isCorrect: true,
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment2ActionIV() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Assess Patient',
			toppx: '370px',
			loadQuiz: true,
			titletext: 'Check IV insertion site',
			isTalks: true,
			extTop: true,
			extImg: 't21',
			extText: 'Intact, no redness, no leakage',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PA2bool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit3);
					this.PA2bool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit3, context.scenario.patientAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action04 = true;
				this.ActionCount = this.OldActionCount - 1;
				context.scenario.destroyAllUIInstances();
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
				context.getFooterCounts2();
			},
			quiz: [
				{
					quizheight: 7,
					quiztop: '5px',
					maxPoints: 50,
					talktext1: 'Patient Assessment',
					talktext2: 'IV Insertion Site',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Intact',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'No redness',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'No leakage',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Redness',
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Leakage',
							onClicked: () => {
							},
						},
						{
							buttontop: '400px',
							buttontext: 'Infection',
							onClicked: () => {
							},
						},
						{
							buttontop: '450px',
							buttontext: 'Non-intact dressing',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -300px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment2ActionPatency() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Actions',
			toppx: '470px',
			loadQuiz: true,
			titletext: 'Catheter: Check Patency',
			isTalks: true,
			extTop: true,
			extImg: 'PDEquipmentStepOne',
			extText: 'Patent',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.CA2bool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
						title: context.scenario.catheter,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit3);
					this.CA2bool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit3, context.scenario.catheter)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action05 = true;
				this.ActionCount = this.OldActionCount - 1;
				context.scenario.destroyAllUIInstances();
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
				context.getFooterCounts2();
			},
			quiz: [
				{
					quizheight: 2,
					quiztop: '5px',
					maxPoints: 100,
					talktext1: 'Catheter',
					talktext2: 'Patency',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Yes',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'No',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -400px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment2ActionColor() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Actions',
			toppx: '570px',
			loadQuiz: true,
			titletext: 'Catheter: Check drainage color and characteristics',
			isTalks: true,
			extTop: true,
			extImg: 't22',
			extText: 'Drainage color: Amber',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.CA2bool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
						title: context.scenario.catheter,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit3);
					this.CA2bool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit3, context.scenario.catheter)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action06 = true;
				this.ActionCount = this.OldActionCount - 1;
				context.scenario.destroyAllUIInstances();
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
				context.getFooterCounts2();
			},
			quiz: [
				{
					quizheight: 4,
					quiztop: '5px',
					maxPoints: 50,
					talktext1: 'Catheter',
					talktext2: 'Drainage color',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Clear',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Straw',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: "Amber",
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: "Dark Red",
							onClicked: () => {
							},
						}
					]
				},
				{
					quizheight: 2,
					prequizheight: 4,
					quiztop: '410px',
					maxPoints: 50,
					talktext1: 'Catheter',
					talktext2: 'Drainage characteristics',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Clear',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Cloudy',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -500px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment2ActionUrine() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Actions',
			toppx: '670px',
			loadQuiz: true,
			titletext: 'Catheter: Check Urine Output',
			isTalks: true,
			extTop: true,
			extImg: 't22',
			extText: 'Output 400 ml',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.CA2bool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
						title: context.scenario.catheter,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit3);
					this.CA2bool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).phillipsNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit3, context.scenario.catheter)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action07 = true;
				this.ActionCount = this.OldActionCount - 1;
				context.scenario.destroyAllUIInstances();
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
				context.getFooterCounts2();
			},
			quiz: [
				{
					quizheight: 4,
					quiztop: '5px',
					maxPoints: 100,
					binaryq: true,
					talktext1: 'Catheter',
					talktext2: 'Urine Output',
					talks: [
						{
							buttontop: '150px',
							buttontext: '500 ml',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: '400 ml',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: '300 ml',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: '100 ml',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -600px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment2ActionRRT() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '770px',
			loadQuiz: true,
			titletext: 'Call RRT',
			isTalks: true,
			onSubmit: () => {
				this.Action08 = true;
				this.ActionCount = this.OldActionCount - 1;
				this.scenario.displayModalPop(
					null,
					'RRT has been notified and is on its way. In the meantime, please continue caring for your patient.',
					() => {
						context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
						context.scenario.destroyAllUIInstances();
						context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
						setTimeout(() => {
							context.scenario.update508Window(Window508Type.TalkActionsUI);
						}, 1000);
						context.getFooterCounts2();
					}
				);
			},
			quiz: [
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -700px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private getFooterCounts2() {
		var context = this;
		this.OldTalkCount = this.TalkCount;
		this.OldActionCount = this.ActionCount;
		if(this.TalkCount === 0 && this.ActionCount === 0) {
			context.scenario.updateFooter('0', '0', true, true);
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			context.scenario.hideFooter();
			context.scenario.update508Window(Window508Type.Main);
			context.segment2PartEndingStart();
		}
		else if(this.TalkCount === 0 && this.ActionCount !== 0) {
			context.scenario.updateFooter('0', this.ActionCount.toString(), true, false);
			context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
			context.scenario.update508Window(Window508Type.Main);
		}
		else if(this.TalkCount !== 0 && this.ActionCount === 0) {
			context.scenario.updateFooter(this.TalkCount.toString(), '0', false, true);
			context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
			context.scenario.update508Window(Window508Type.Main);
		}
		else {
			context.scenario.updateFooter(this.TalkCount.toString(), this.ActionCount.toString(), false, false)
		};
	}

	private checkIfSubMenu3() {
		var context = this;
		if(this.Action011 === true && this.Action012 === true && this.Action013 === true && this.Action014 === true && this.Action015 === true) {
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);	
			this.Action01 = true;
			this.ActionCount = this.OldActionCount - 1;
		};
		context.getFooterCounts2();
	}

	private segment2PartEndingStart() {
		var context = this;
    	context.segment3PreloadUis();
	}

	private segment3PreloadUis() {
        var context = this;

		context.scenario.gameManager.UiManager.updateUIInstance(this.ActionInstanceID1, {
			talks: [
				{
					toppx: '50px',
					titletext: 'Put non-rebreather mask on patient',
					onClicked: () => {
						this.segment3ActionMask();
					},
					disable: () => this.Action001
				},
				{
					toppx: '150px',
					titletext: 'Increase IV fluids',
					onClicked: () => {
						context.segment3ActionIV();
					},
					disable: () => this.Action002
				},
				{
					toppx: '250px',
					titletext: 'Give patient a drink of water',
					onClicked: () => {
						context.segment3ActionDrink();
					},
					disable: () => this.Action003
				},
				{
					toppx: '350px',
					titletext: 'Reposition bed to Trendelenburg',
					onClicked: () => {
						context.segment3ActionBed();
					},
					disable: () => this.Action004
				}
			]
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);

		context.ActionCount = 4;
		context.getFooterCounts3();
	}

	private segment3ActionMask() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '70px',
			loadQuiz: true,
			titletext: 'Put non-rebreather mask on patient',
			isTalks: true,
			onSubmit: () => {
				this.Action001 = true;
				this.ActionCount = this.OldActionCount - 1;
				context.scenario.gameManager.environment.blurFadeIn();
				context.scenario.destroyAllUIInstances();
				setTimeout(() => {
					this.rebreatherChanged = true;
					this.playVideoChapter(this.chapterIds.chapterCinematic78, () => {}, true);
				}, 1000)
				setTimeout(() => {
					context.scenario.gameManager.environment.blurFadeOut();
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1500);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
				context.getFooterCounts3();
			},
			quiz: [
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment3ActionIV() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '170px',
			loadQuiz: true,
			titletext: 'Increase IV fluids',
			isTalks: true,
			onSubmit: () => {
				this.Action002 = true;
				this.ActionCount = this.OldActionCount - 1;
				context.scenario.destroyAllUIInstances();
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
				context.getFooterCounts3();
			},
			quiz: [
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment3ActionDrink() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '270px',
			loadQuiz: true,
			titletext: 'Give patient a drink of water',
			isTalks: true,
			onSubmit: () => {
				this.Action003 = true;
				this.ActionCount = this.OldActionCount - 1;
				this.scenario.displayModalPop(
					null,
					"Keep your patient NPO if you're anticipating surgery. Please try again.",
					() => {
						context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
						context.scenario.destroyAllUIInstances();
						context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
						setTimeout(() => {
							context.scenario.update508Window(Window508Type.TalkActionsUI);
						}, 1000);
						context.getFooterCounts3();
					}
				);
			},
			quiz: [
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment3ActionBed() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '370px',
			loadQuiz: true,
			titletext: 'Reposition bed to Trendelenburg',
			isTalks: true,
			onSubmit: () => {
				this.Action004 = true;
				this.ActionCount = this.OldActionCount - 1;
				this.scenario.displayModalPop(
					null,
					'Your patient will have respiratory difficulty in this position. Please try again.',
					() => {
						context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
						context.scenario.destroyAllUIInstances();
						context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
						setTimeout(() => {
							context.scenario.update508Window(Window508Type.TalkActionsUI);
						}, 1000);
						context.getFooterCounts3();
					}
				);
			},
			quiz: [
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -300px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private getFooterCounts3() {
		var context = this;
		this.OldTalkCount = this.TalkCount;
		this.OldActionCount = this.ActionCount;
		if(this.Action001 === true && this.Action002 === true) {
			context.scenario.updateFooter('0', '0', true, true);
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			context.scenario.update508Window(Window508Type.Main);
			context.scenario.hideFooter();
			this.playVideoChapter(this.chapterIds.chapterCinematic47, () => {
				context.scenario.gameManager.environment.blurFadeIn();
				context.segment3showSbar();
			});
		}
		else {
			context.scenario.updateFooter(this.TalkCount.toString(), this.ActionCount.toString(), true, false)
		};
	}

	private segment3showSbar() {
		var context = this;
		context.scenario.update508Window(Window508Type.SbarUI)
		this.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.SbarUI, {
			s: {
				maxPoints: 250,
				options: [
					{
						text: 'Drop in patients vitals',
						isCorrect: true
					},
					{
						text: 'Increased bleeding found in peri-pad',
						isCorrect: true
					},
					{
						text: 'Patrient is weak and lightheaded',
						isCorrect: true
					},
					{
						text: 'Change in LOC',
						isCorrect: true
					},
					{
						text: 'Hypoglycemia',
						isCorrect: false
					}
				]
			},
			basic: this.scenario.getScenarioDataEntryItems((this.scenario as Scenario2).phillipsBasicID),
			nurses: this.scenario.getScenarioDataEntryItems((this.scenario as Scenario2).phillipsNursesID),
			r: {
				maxPoints: 200,
				options: [
					{
						text: 'Medication',
						isCorrect: false
					},
					{
						text: 'Transfer care to OR',
						isCorrect: true
					},
					{
						text: 'CT Scan',
						isCorrect: false
					},
					{
						text: 'Discharge',
						isCorrect: false
					}
				]
			},
			correctFeedback: 'Good job, you have correctly relayed critical information. Please review the SBAR and continue.',
			incorrectFeedback: 'You have incorrectly relayed critical information. Accurate patient information ensures patient safety and quality care provided by medical staff and Providers. Please continue to review the corrected SBAR.',
			onSubmitted: (result: SbarUIConfig) => {
				this.scenario.evaluateScoreForSbar(result);
			},
			onClose: (result: SbarUIConfig) => {
				context.scenario.destroyAllUIInstances();
				context.scenario.showProvider(
					"Thanks, we'll take Mrs. Phillips to the OR. Great job!",
					() => {
						context.segment1Part5Debrief();
					}
				);
			},
			onSetWindow: (window: Window508Type) => {
				context.scenario.update508Window(window);
			}
		});
	}
}